import React from "react"
import { Box } from "@mui/system"
import { Grid, Typography } from "@mui/material"
import PropTypes from "prop-types"
import theme from "../../../../theme/theme"

const InfoItem = ({ label, value }) => {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: "5px" }}>
            <Typography
                variant="contraHeading"
                sx={{ color: theme.palette.primary.white70 }}
            >
                {label}
            </Typography>
            <Typography variant="textBody" color="common.white">
                {value}
            </Typography>
        </Box>
    )
}

InfoItem.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
}

export const BoxDataEventFlow = ({ eventFlowData }) => {
    const formatDate = (date) => {
        if (!date) return "-"
        try {
            return new Intl.DateTimeFormat("pt-BR").format(new Date(date))
        } catch {
            return "-"
        }
    }

    const formatValue = (value) => {
        if (!value) return "-"
        try {
            return new Intl.NumberFormat("pt-BR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)
        } catch {
            return "-"
        }
    }
    return (
        <Box display="flex" gap={3} flexDirection="column">
            <Typography variant="h3" color="common.white">
                Parâmetros para Cálculo de Preços
            </Typography>

            <Box
                sx={{
                    display: "flex",
                    flexDirection: { xxxs: "column" },
                    gap: 0.125,
                    alignItems: "stretch",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: { xxxs: "column", md: "row" },
                        gap: 0.125,
                    }}
                >
                    <Grid
                        container
                        pt={3}
                        pb={3}
                        pl={3}
                        sx={{
                            display: "flex",
                            flexDirection: { xxxs: "column", xs: "row" },
                            width: { xxxs: "100%", md: "38%" },
                            background:
                                "linear-gradient(146.22deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 100%)",
                        }}
                    >
                        <Grid
                            item
                            xxxs={2}
                            md={6}
                            lg={6}
                            sm={1}
                            sx={{
                                whiteSpace: "nowrap",
                                paddingBottom: { xxxs: 3, xs: 0 },
                            }}
                        >
                            <InfoItem
                                label="Tipo juros PUPAR"
                                value={eventFlowData?.TipoJurosPUPAR ?? "-"}
                            />
                        </Grid>
                        <Grid
                            item
                            xxxs={2}
                            md={6}
                            lg={6}
                            sm={1}
                            sx={{ whiteSpace: "nowrap" }}
                        >
                            <InfoItem
                                label="Tipo capitalização PUPAR"
                                value={
                                    eventFlowData?.TipoCapitalizacaoPUPAR ?? "-"
                                }
                            />
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        pt={3}
                        pb={3}
                        pl={3}
                        sx={{
                            display: "flex",
                            flexDirection: { xxxs: "column", xs: "row" },
                            width: { xxxs: "100%", md: "62%" },
                            background:
                                "linear-gradient(90.8deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 100%)",
                        }}
                    >
                        <Grid
                            item
                            xxxs={2}
                            md={3}
                            lg
                            sx={{
                                whiteSpace: "nowrap",
                                paddingBottom: { xxxs: 3, xs: 0 },
                            }}
                        >
                            <InfoItem
                                label="Início rentabilidade"
                                value={formatDate(
                                    eventFlowData?.InicioRentabilidade
                                )}
                            />
                        </Grid>
                        <Grid
                            item
                            xxxs={2}
                            md={3}
                            lg
                            sx={{
                                whiteSpace: "nowrap",
                                paddingBottom: { xxxs: 3, xs: 0 },
                            }}
                        >
                            <InfoItem
                                label="Fim rentabilidade"
                                value={formatDate(
                                    eventFlowData?.FimRentabilidade
                                )}
                            />
                        </Grid>

                        <Grid
                            item
                            xxxs={2}
                            md={3}
                            lg
                            sx={{
                                whiteSpace: "nowrap",
                                paddingBottom: { xxxs: 3, xs: 0 },
                            }}
                        >
                            <InfoItem
                                label="Valor nominal"
                                value={formatValue(eventFlowData?.ValorNominal)}
                            />
                        </Grid>

                        <Grid item xxxs={2} md={3} lg>
                            <InfoItem
                                label="Defasagem"
                                value={formatValue(eventFlowData?.Defasagem)}
                            />
                        </Grid>
                    </Grid>
                </Box>
                <Box
                    display="flex"
                    gap={0.125}
                    sx={{
                        flexDirection: { xxxs: "column", md: "row" },
                    }}
                >
                    <Grid
                        container
                        pt={3}
                        pb={3}
                        pl={3}
                        sx={{
                            display: "flex",
                            flexDirection: { xxxs: "column", xs: "row" },
                            width: { xxxs: "100%", md: "38%" },
                            background:
                                "linear-gradient(146.22deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 100%)",
                        }}
                    >
                        <Grid
                            item
                            xxxs={2}
                            md={6}
                            lg={6}
                            sm={1}
                            sx={{
                                whiteSpace: "nowrap",
                                paddingBottom: { xxxs: 3, xs: 0 },
                            }}
                        >
                            <InfoItem
                                label="Tipo juros PU MTM"
                                value={eventFlowData?.TipoJurosPU_MTM ?? "-"}
                            />
                        </Grid>
                        <Grid
                            item
                            xxxs={2}
                            md={6}
                            lg={6}
                            sm={1}
                            sx={{ whiteSpace: "nowrap" }}
                        >
                            <InfoItem
                                label="Tipo capitalização PU MTM"
                                value={
                                    eventFlowData?.TipoCapitalizacaoPU_MTM ??
                                    "-"
                                }
                            />
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        pt={3}
                        pb={3}
                        pl={3}
                        sx={{
                            display: "flex",
                            flexDirection: { xxxs: "column", xs: "row" },
                            width: { xxxs: "100%", md: "62%" },
                            background:
                                "linear-gradient(90.8deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 100%)",
                        }}
                    >
                        <Grid
                            item
                            xxxs={2}
                            md={3}
                            lg
                            sx={{
                                pb: {
                                    xs: 3,
                                    md: 0,
                                },
                            }}
                        >
                            <InfoItem
                                label="Inflação anual"
                                value={formatValue(
                                    eventFlowData?.InflacaoAnual
                                )}
                            />
                        </Grid>
                        <Grid item xxxs={2} md={3} lg>
                            <InfoItem
                                label="Mês aniversário"
                                value={eventFlowData?.MesAniversario ?? "-"}
                            />
                        </Grid>

                        <Grid item xxxs={2} md={3} lg>
                            <InfoItem
                                label="Projeção inflação"
                                value={formatDate(
                                    eventFlowData?.ProjecaoInflacao
                                )}
                            />
                        </Grid>

                        <Grid item xxxs={2} md={3} lg>
                            <InfoItem
                                label="Inflação negativa"
                                value={formatValue(
                                    eventFlowData?.InflacaoNegativa
                                )}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Box>
    )
}
BoxDataEventFlow.propTypes = {
    eventFlowData: PropTypes.shape({
        TipoJurosPUPAR: PropTypes.string,
        TipoCapitalizacaoPUPAR: PropTypes.string,
        TipoJurosPU_MTM: PropTypes.string,
        TipoCapitalizacaoPU_MTM: PropTypes.string,
        InicioRentabilidade: PropTypes.string,
        FimRentabilidade: PropTypes.string,
        ValorNominal: PropTypes.number,
        Defasagem: PropTypes.number,
        InflacaoAnual: PropTypes.number,
        MesAniversario: PropTypes.number,
        ProjecaoInflacao: PropTypes.string,
        InflacaoNegativa: PropTypes.number,
    }),
}
